<template>
  <div class="company-core-detail">
    <div class="core-detail-head">
      <bcc-breadcrumb>
        <bcc-breadcrumb-item>管理中心</bcc-breadcrumb-item>
        <bcc-breadcrumb-item :to="{name: 'companyCore'}" @click.native="$LogReport.sendCustomEvent('openplat_checkapp_backto_appmanage')">应用管理</bcc-breadcrumb-item>
        <bcc-breadcrumb-item>应用详情</bcc-breadcrumb-item>
      </bcc-breadcrumb>
    </div>
    <div class="core-detail-body">
      <div class="core-detail-body-h">
        <div>
          <div class="avatar" :style="{backgroundImage: renderAvatar(cover)}"></div>
          <div class="detail">
            <div class="detail-s">
              <span class="title">{{app_name}}</span>
              <span class="state" style="background-color: #FAAB4B;" v-if="state === 0">待审核</span>
              <span class="state" style="background-color: #00A1D6;" v-if="state === 1">已开通</span>
              <span class="state" style="background-color: #FA5A57;" v-if="state === 2">已拒绝</span>
            </div>
            <div class="detail-s">
              <span class="label">Client ID:</span>
              <span class="value">{{$route.params.client_id}}</span>
            </div>
            <div class="detail-s">
              <span class="label">App Secret:</span>
              <span class="value">{{getSecret}}</span>
              <span @click="$LogReport.sendCustomEvent('openplat_appsecret_click')">
                <img src="../../assets/icon/icon_code_hover.png" alt="" class="hidden" v-if="showSecret" @click="showSecret = false">
              <img src="../../assets/icon/icon_view_normal.png" alt="" class="hidden" v-else @click="showSecret = true">
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 应用信息 -->
      <div class="core-detail-body-p" v-if="app_info">
          <div class="p-h" style="display: flex; justify-content: space-between">
            <span>应用信息</span>
            <router-link
                v-if="state !== 0"
                :to="{name: 'companyCoreAdd', query: {client_id: client_id}}"
                @click.native="$LogReport.sendCustomEvent('openplat_checkapp_edit_click')"
            ><bcc-icon  type="Mediumx" class="edit-button"></bcc-icon>编辑
            </router-link>
          </div>
        <div class="p-b">
          <div class="p-b-b">
            <div class="label">网站应用简介：</div>
            <div class="value">{{app_info.dsc}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">应用官网：</div>
            <div class="value">{{app_info.site}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">网站应用图标：</div>
            <div class="app-avatar" :style="{backgroundImage: renderAvatar(app_info.cover)}"></div>
          </div>
        </div>
      </div>
      <!-- web应用 -->
      <div class="core-detail-body-p" v-if="app_info && app_info.app_plat.includes(2)">
        <h3 class="p-h">网页应用</h3>
        <div class="p-b">
          <div class="p-b-b">
            <div class="label">应用回调域：</div>
            <div class="value">{{app_info.oauth_info.cburl}}</div>
          </div>
        </div>
      </div>
      <!-- 移动应用 - ios 平台 -->
      <div class="core-detail-body-p" v-if="app_info && app_info.app_plat.includes(0)">
        <h3 class="p-h">iOS平台</h3>
        <div class="p-b">
          <div class="p-b-b">
            <div class="label">应用已上架</div>
            <div class="value">{{app_info.ios_oauth_info.is_online ? '是' : '否'}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">AppStore下载地址：</div>
            <div class="value">{{app_info.ios_oauth_info.download_url}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">Bundle ID：</div>
            <div class="value">{{app_info.ios_oauth_info.bundle_id}}</div>
          </div>
        </div>
      </div>
      <!-- 移动应用 - android 平台 -->
      <div class="core-detail-body-p" v-if="app_info && app_info.app_plat.includes(1)">
        <h3 class="p-h">Android平台</h3>
        <div class="p-b">
          <div class="p-b-b">
            <div class="label">应用已上架：</div>
            <div class="value">{{app_info.android_oauth_info.is_online ? '是' : '否'}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">Android下载地址：</div>
            <div class="value">{{app_info.android_oauth_info.download_url}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">应用包名：</div>
            <div class="value">{{app_info.android_oauth_info.apk_name}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">应用签名：</div>
            <div class="value">{{app_info.android_oauth_info.apk_sign}}</div>
          </div>
        </div>
      </div>

      <!-- 管理者信息 -->
      <div class="core-detail-body-p" v-if="user_info">
        <h3 class="p-h">管理者信息</h3>
        <div class="p-b">
          <div class="p-b-b">
            <div class="label">联系人：</div>
            <div class="value">{{user_info.contact}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">联系邮箱：</div>
            <div class="value">{{user_info.email}}</div>
          </div>
          <div class="p-b-b">
            <div class="label">联系手机：</div>
            <div class="value">{{user_info.tel}}</div>
          </div>
        </div>
      </div>

      <div class="core-detail-body-p" v-if="user_info">
        <div class="p-h" style="display: flex; justify-content: space-between">
          <span>Webhooks用户事件推送</span>
          <router-link
            v-if="state !== 0"
            :to="{name: 'companyCoreAdd', query: {client_id: this.client_id, callback_url: user_info.callback_url, webhooks: true}}"
            @click.native="$LogReport.sendCustomEvent('openplat_webhooks_edit')"
          ><bcc-icon type="Mediumx" class="edit-button"></bcc-icon>编辑
          </router-link>
        </div>
        <div class="p-b">
          <div class="p-b-b">
            <div class="label">消息回调地址：</div>
            <div class="value">{{user_info.callback_url}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  data() {
    return {
      showSecret: false,
      app_name: '',
      secret: '',
      cover: '',
      client_id: this.$route.params.client_id,
      app_plat: [],
      app_info: null,
      user_info: null,
      state: null
    }
  },
  created() {
    const companyInfo = this.$store.state.companyInfo
    if (companyInfo && companyInfo.state === 1) {
      this.$LogReport.sendCustomEvent('openplat_checkapp_page_load')
      this.getCompanyCoreDetail().catch(e => {
        this.$message({
          content: e.message,
          type: 'exception',
          offset: 60,
          duration: 1500
        })
      })
    } else {
      this.$router.push({
        name: 'companyCore'
      })
    }
  },
  computed: {
    getSecret() {
      if (this.showSecret) {
        return this.secret
      } else {
        return new Array(this.secret.length).fill('*').join('')
      }
    }
  },
  methods: {
    async getCompanyCoreDetail() {
      const client_id = this.$route.params.client_id
      const data = await this.$api.companyCore.view(client_id) 
      this.app_name = data.app_name
      this.secret = data.secret
      this.cover = data.cover
      this.app_plat = data.app_plat
      this.state = data.state

      this.user_info = {
        contact: data.contact,
        tel: data.tel,
        email: data.email,
        callback_url: data.callback_url || '-'
      }

      this.app_info = {
        app_name: data.app_name,
        dsc: data.dsc,
        site: data.site,
        cover: data.cover,
        app_plat: data.app_plat,
        ios_oauth_info: data.ios_oauth_info || {
          is_online: 0,
          download_url: '',
          bundle_id: ''
        },
        android_oauth_info: data.android_oauth_info || {
          is_online: 0,
          download_url: '',
          apk_name: '',
          apk_sign: ''
        },
        oauth_info: data.oauth_info || {
          cburl: '',
          site: ''
        },
      }
    },
    renderAvatar(cover) {
      if (cover) {
        return `url(${this.replaceHTTPResource(cover)})`
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.company-core-detail {
  min-width: 960px;
  width: 100%;
  max-width: 1168px;
  margin: auto;
  padding-bottom: 32px;
}
.core-detail-head {
  padding: 32px 0 34px 26px;
}
.core-detail-body {
  border: 1px solid #E7E7E7;
  min-height: 100px;
  .core-detail-body-h {
    padding: 25px 26px 16px;
    > div {
      height: 144px;
      background: #FAFAFA;
      border-radius: 4px;
      display: flex;
      align-items: center;
      .avatar {
        width: 98px;
        height: 98px;
        background-color: #999999;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 5px;
        margin: 0 24px;
      }
      .detail {
        .detail-s + .detail-s {
          margin-top: 18px;
        }
        .title {
          font-size: 24px;
          color: #222222;
          line-height: 24px;
          font-weight: 600;
          vertical-align: middle;
        }
        .state {
          margin-left: 20px;
          background: #00A1D6;
          border-radius: 2px;
          padding: 4px;
          font-size: 14px;
          color: #FFFFFF;
          letter-spacing: 1px;
          line-height: 14px;
          font-weight: 400;
          vertical-align: middle;
        }
        .label {
          font-size: 14px;
          color: #999999;
          line-height: 14px;
          font-weight: 400;
          vertical-align: middle;
          user-select: none;
        }
        .value {
          font-size: 14px;
          color: #222222;
          line-height: 14px;
          font-weight: 400;
          margin-left: 15px;
          vertical-align: middle;
          font-family: Consolas, Monaco, monospace;
        }
        .hidden {
          height: 16px;
          cursor: pointer;
          width: auto;
          vertical-align: middle;
          margin-left: 24px;
        }
      }
    }
  }

  .core-detail-body-p {
    padding: 0 26px 16px;
    .p-h {
      padding: 16px 34px;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 #E7E7E7;
      font-size: 14px;
      color: #222222;
      line-height: 22px;
      font-weight: 500;
    }
    .p-b {
      padding: 16px 0 32px;
      .p-b-b + .p-b-b {
        margin-top: 16px;
      }
      .p-b-b {
        display: flex;
      }

      .label {
        width: 214px;
        box-sizing: border-box;
        font-size: 14px;
        color: #999999;
        line-height: 22px;
        font-weight: 400;
        padding-left: 34px;
      }
      .app-avatar {
        width: 60px;
        height: 60px;
        background-color: #999999;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 5px;
      }
      .value {
        font-size: 14px;
        color: #505050;
        text-align: left;
        line-height: 22px;
        font-weight: 400;
        flex: 1;
      }
    }
    .edit-button {
      margin-right: 8px
    }
  }
}
</style>
